export default "This view shows information on calls dispatched from PBX.\n\nA recap chart provides aggregated data, then a table displays detailed CDR data\n";